import { render, staticRenderFns } from "./MenuAccountPage.vue?vue&type=template&id=0b0e8018"
import script from "./MenuAccountPage.vue?vue&type=script&lang=js"
export * from "./MenuAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports